import {combineReducers} from "redux";
import orgReducer from "./reducer";

const reducer = combineReducers({
    orgReducer,
})
  
export default reducer;